import { ToolbarMenuComponent } from 'src/app/shared/components';
import { cloneDeep } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd } from '@angular/router';

// KS, 20260204
import { LauncherTypes } from 'src/app/shared/constants';

@Component({
  selector: 'app-secondary-menu',
  templateUrl: './secondary-menu.component.html',
  styleUrls: ['./secondary-menu.component.scss'],
})
export class SecondaryMenuComponent extends ToolbarMenuComponent implements OnInit {
  ngOnInit() {
    this.sub$.push(
      this.context$.subscribe((data) => {

        // KS, 20260204
        /*
        let newDashboardItem = cloneDeep(data.menuItems.secondary[0]);
        newDashboardItem.id = '#8';
        newDashboardItem.key = newDashboardItem.key.split('DASHBOARD_')[0] + 'NEW';
        newDashboardItem.path = '/v2/dashboard';
        newDashboardItem.text = 'New Dashboard';
        newDashboardItem.label = 'New Dashboard';
        newDashboardItem.level = 1;
        newDashboardItem.order = 5;
        data.menuItems.secondary.push(newDashboardItem);
        console.info('################, newDashboardItem=', newDashboardItem);
        */

        this.context = data;
        this.menuItems = cloneDeep(data.menuItems.secondary);
        this.markActiveItems(this.menuItems);
        this.currentItem = this.getActivatedLink(this.menuItems);
      })
    );
    this.sub$.push(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.updateMenuState();
        }
      })
    );
  }

  updateMenuState() {
    this.markActiveItems(this.menuItems);
    this.previousItem = this.currentItem;
    this.currentItem = this.getActivatedLink(this.menuItems);
  }

  handleFolderNavigation(item: any) {
    this.openSubMenu(item);
  }
}
